var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHintIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_55_1045",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7197 5C52.6858 5 66.4395 18.7537 66.4395 35.7197C66.4395 52.6858 52.6858 66.4395 35.7197 66.4395C18.7537 66.4395 5 52.6858 5 35.7197C5 18.7537 18.7537 5 35.7197 5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.7197 5C52.6858 5 66.4395 18.7537 66.4395 35.7197C66.4395 52.6858 52.6858 66.4395 35.7197 66.4395C18.7537 66.4395 5 52.6858 5 35.7197C5 18.7537 18.7537 5 35.7197 5Z",
    fill: "#F04E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7197 5V10C49.9243 10 61.4395 21.5151 61.4395 35.7197H66.4395H71.4395C71.4395 15.9923 55.4472 0 35.7197 0V5ZM66.4395 35.7197H61.4395C61.4395 49.9243 49.9243 61.4395 35.7197 61.4395V66.4395V71.4395C55.4472 71.4395 71.4395 55.4472 71.4395 35.7197H66.4395ZM35.7197 66.4395V61.4395C21.5151 61.4395 10 49.9243 10 35.7197H5H0C0 55.4472 15.9923 71.4395 35.7197 71.4395V66.4395ZM5 35.7197H10C10 21.5151 21.5151 10 35.7197 10V5V0C15.9923 0 0 15.9923 0 35.7197H5Z",
    fill: "white",
    mask: "url(#path-1-outside-1_55_1045)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintIcon);
export default __webpack_public_path__ + "static/media/hint_icon.eba0600a37fc2ef999863795d6505ca9.svg";
export { ForwardRef as ReactComponent };